import { z } from 'zod/v4';
import { labelsSchema, timeSeriesValueTupleSchema } from './time-series';

/**
 * Zod schemas for SingleValueDataResponse and SingleValueTimeSeriesDataResponse.
 */

export const singleValueSchema = z.object({
  name: z.string(),
  value: z.union([z.number(), z.null()]),
  formattedName: z.string().optional(),
  labels: labelsSchema.optional(),
  config: z.any().optional(),
});

export const singleValueDataSchema = z.object({
  values: z.array(singleValueSchema),
  metadata: z.any().optional(),
});

export const singleValueDataResponseSchema = z.object({
  type: z.literal('SingleValue'),
  data: singleValueDataSchema,
});

export const singleValueTimeSeriesSchema = z.object({
  name: z.string(),
  value: z.union([z.number(), z.null()]),
  timeSeries: z.array(timeSeriesValueTupleSchema),
  formattedName: z.string().optional(),
  labels: labelsSchema.optional(),
  config: z.any().optional(),
});

export const singleValueTimeSeriesDataSchema = z.object({
  values: z.array(singleValueTimeSeriesSchema),
  metadata: z.any().optional(),
});

export const singleValueTimeSeriesDataResponseSchema = z.object({
  type: z.literal('SingleValueTimeSeries'),
  data: singleValueTimeSeriesDataSchema,
});

export type SingleValueDataResponseSchema = z.infer<typeof singleValueDataResponseSchema>;
export type SingleValueTimeSeriesDataResponseSchema = z.infer<typeof singleValueTimeSeriesDataResponseSchema>;
